import { RootState } from 'types'
import produce from 'immer'
import { AssignedProperty, Assignee } from 'api/clients/PropertyClient'
import { Action } from 'redux/actions'

type State = RootState['filesProperties']

export default function reduce(state: State = {}, action: Action): State {
  switch (action.type) {
    case 'SET_FILES_PROPERTIES_LOADING_STATE': {
      const { payload } = action
      const { assignees, propertiesIds, loadingState } = payload

      return produce(state, (draft) => {
        assignees.forEach(({ id: assignee_id }) => {
          propertiesIds.forEach((propertyId) => {
            draft[assignee_id] = draft[assignee_id] || {}
            draft[assignee_id][propertyId] = draft[assignee_id][propertyId] || {}
            draft[assignee_id][propertyId].loadingState = loadingState
          })
        })
      })
    }
    case 'UPSERT_FILES_PROPERTIES': {
      const { assignedProperties } = action.payload

      return produce(state, (draft) => {
        assignedProperties.forEach(({ assignee_id, property, id, property_values }: AssignedProperty) => {
          draft[assignee_id] = draft[assignee_id] || {}
          draft[assignee_id][property.id] = draft[assignee_id][property.id] || {}
          draft[assignee_id][property.id].id = id
          draft[assignee_id][property.id].values = property_values
        })
      })
    }

    case 'DELETE_FILES_PROPERTIES': {
      const { assignees, propertyId } = action.payload

      return produce(state, (draft) => {
        assignees.forEach((assignee: Assignee) => {
          draft[assignee.id] = draft[assignee.id] || {}
          delete draft[assignee.id][propertyId]
        })
      })
    }
    default:
      return state
  }
}
